import { WinDeriv_CalculatedBase, WinDerivBase } from "./common"

export interface Win extends WinDerivBase {
    nonRunnerEntities?: Win_NonRunner[],
    fieldMoney?:number,

    calculated?: WinCalculated,

    sampleMarketDeductions?: Win_SampleMarketDeduction[] // TODO: Where does this come from, it's not in pricing API at the moment?
}

export type Win_NonRunner = {
    runnerId: string,
    lastMarketUpdateId: string,
    scratchType:NonRunnerScratchType
}

export interface WinCalculated extends WinDeriv_CalculatedBase {
    overroundTotal: string
}

export type Win_SampleMarketDeduction = {
    marketType: string;
    marketDesc: string;
}

export enum NonRunnerScratchType {
    NONRUNNER = 'non_runner',
    WITHDRAWN = 'withdrawn',
    RESERVE_RUNNER = 'reserve_runner',
    VACANT = 'vacant_trap',
}
